import { useQuery } from "react-query";

import { listTargetMarkers } from "api/targets";
import { GET_TARGET_MARKERS, STALE_TIME_1_MINUTES } from "@constants/reactQueryKeys";

/**
 * Fetches the markers annotating a target's data chart. Returns them oldest
 * first (as the backend does). Disabled for invalid (falsy/NaN) target ids.
 */
const useListTargetMarkers = (targetId: number) => {
  const {
    data: response,
    isLoading,
    error,
    ...rest
  } = useQuery([GET_TARGET_MARKERS, targetId], () => listTargetMarkers(targetId), {
    enabled: !!targetId,
    staleTime: STALE_TIME_1_MINUTES,
    refetchOnWindowFocus: false,
    retry: 2,
  });

  return {
    markers: response?.data ?? [],
    isLoadingMarkers: isLoading,
    markersError: error,
    ...rest,
  };
};

export default useListTargetMarkers;
